import React, { useCallback, useEffect, useState } from 'react'
import { Badge, Drawer, Paper } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import GlobalNotificationIcon from '../../assets/icons/GlobalNotificationIcon'
import { ExtraSmallButton, NonInteractiveTooltip } from '../custom'
import { mergeSideBarBottomButtonSx } from '../sideBarRight/sideBarBottomIconButtonSx'
import {
    createOverlayDrawerOnClose,
    sideBarOverlayDrawerPaperProps,
    sideBarOverlayDrawerProps,
    useSideBarOverlayDrawerEscape
} from '../sideBarRight/sideBarOverlayDrawerProps'
import { selectGlobalNotifications } from '../../selectors/globalNotification'
import { selectRightSidebarWidget } from '../../selectors/common'
import commonActions from '../../actions/common.actions'
import { WidgetListItems } from '../../util/sidebar'
import GlobalNotification from './GlobalNotification'

export function GlobalNotificationDrawer() {
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false)
    const notifications = useSelector(selectGlobalNotifications)
    const rightSideWidget = useSelector(selectRightSidebarWidget)

    useEffect(() => {
        if (rightSideWidget === WidgetListItems.NOTIFICATION) {
            setOpen(true)
            commonActions.dispatchRightSideWidget(dispatch, null)
        }
    }, [rightSideWidget, dispatch])

    const handleClose = useCallback(() => {
        setOpen(false)
    }, [])

    useSideBarOverlayDrawerEscape(open, handleClose)

    const handleButtonClick = useCallback(() => {
        setOpen(prev => !prev)
    }, [])

    return (
        <div>
            <NonInteractiveTooltip arrow placement="left" title="Notification" describeChild>
                <span>
                    <ExtraSmallButton
                        aria-label={notifications.length ? `Notifications (${notifications.length})` : 'Notifications'}
                        size="small"
                        color="inherit"
                        onClick={handleButtonClick}
                        data-event="Notifications Icon Clicked"
                        data-event-action={open ? 'Closed' : 'Opened'}
                        sx={mergeSideBarBottomButtonSx(theme => ({
                            backgroundColor: open ? theme.palette.action.selected : 'transparent'
                        }))}
                    >
                        <Badge badgeContent={notifications.length} color="primary" overlap="circular" slotProps={{ badge: { 'aria-hidden': true } }}>
                            <GlobalNotificationIcon />
                        </Badge>
                    </ExtraSmallButton>
                </span>
            </NonInteractiveTooltip>

            <Drawer
                anchor="right"
                open={open}
                onClose={createOverlayDrawerOnClose(handleClose)}
                {...sideBarOverlayDrawerProps}
                PaperProps={sideBarOverlayDrawerPaperProps}
            >
                <Paper
                    sx={{
                        p: 4,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        boxSizing: 'border-box',
                        borderRadius: 0
                    }}
                >
                    <GlobalNotification onClose={handleClose} />
                </Paper>
            </Drawer>
        </div>
    )
}
